import { Component, OnInit } from '@angular/core';
import { CommanService } from 'src/app/shared/services/comman.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment'

@Component({
  selector: 'app-albums',
  templateUrl: './albums.component.html',
  styleUrls: ['./albums.component.scss']
})
export class AlbumsComponent implements OnInit {

  gallerySlug: any = "";
  galleryList: any = "";
  galleryRequest: any = {
    page: 1,
    pagesize: 9
  };
  galleryList_last_page: boolean;


  constructor(
    private commanService: CommanService,
    private activatedRoute:ActivatedRoute,
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((data)=>{
      if(data.slug){
        this.gallerySlug = data.slug;
        this.loadGallery(data.slug);
      }
    });
  }

  getMoreGallery() {
    this.galleryRequest.page = this.galleryRequest.page + 1;
    this.loadGallery(this.gallerySlug, true);
    
  }

  loadGallery(slug, concat:boolean = false){
    //this.galleryRequest.lang =  this.browserLang;
    this.galleryRequest.slug = slug;
    let request = Object.assign({}, this.galleryRequest)
    //this.request.mediagallery_group_id = albumid;
    //let request = Object.assign({}, this.request)
    this.commanService.getGallery(request).then((data : any) => { 
      //this.analyticsRequest.event_label =  data.title;
      //this.loadanalytics();
    if(data.data.length > 0)
    {
      if (concat) {
      
      
          this.galleryList = this.galleryList.concat(data);
          
          //console.log(this.galleryList);
         // this.callshare();
        } else {
          this.galleryList = data;
         // this.galleryTitle = data.title;
          //console.log(this.galleryList);
          //this.callshare();
        }   
    }
    else{
      this.galleryList_last_page = true;
      //console.log("hello");
    }
  });
  }

}
